import styled, {css} from 'styled-components';
import StyledLoader from 'StyledLoader.js';
import {Form, Input, Button} from 'global/styles/styles.js';
import {rem} from 'polished';

const FontFamily = ({theme: {$fontFamily}}) => `${$fontFamily}`;
const FontFamilyOswald = ({theme: {$textOswaldRegular}}) => `${$textOswaldRegular}`;
const FwRegular = ({theme:{$fwRegular}}) => `${$fwRegular}`;
const FwMedium = ({theme:{$fwMedium}}) => `${$fwMedium}`;
const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;
const FwBold = ({theme:{$fwBold}}) => `${$fwBold}`;



const baseFont = `16px`;

const S = {};

S.ResponsibleGamingForm = styled(Form)`
    width: auto !important;
    font-family: ${FontFamily};
    font-weight: ${FwSemibold};
    margin: ${rem('17px', baseFont)} ${rem('10px', baseFont)} ${rem('20px', baseFont)} ${rem('10px', baseFont)} !important;
    ${({modal})=>{
        if(modal==true){
            return css`
                ${rem('17px', baseFont)} 0 ${rem('20px', baseFont)} 0 !important;
            `;
        }    
    }}
`;

S.CloseModalButton = styled(Button)`
    position: absolute;
    right: -40px;
    top: -40px;
    padding: 0;
    width: 2.8rem;
    height: 2.8rem;
    transform: none;
    line-height: 1;
    margin-right: -3rem;
    margin-top: -3rem;
    border-radius: 50%;
    bottom: 0;
    margin: .83rem 0;
    background: #fff url(/images/svg/header_close_black.svg) no-repeat 50% 50%;
    background-size: 1.47rem 1.47rem;
    cursor: pointer;
`;

S.LoaderWrapper = styled.div`
    width: auto;
`;

S.Row = styled.div`
    width: 100%;
`;

S.Cover = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: transparent;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 5;
    
    & ${StyledLoader.LoaderWrapper}{
    }
`;


S.Label = styled.label`
    font-size: ${rem('12px', baseFont)};
    color: ${({theme:{$accountResponsibleGameFormLabel}})=> $accountResponsibleGameFormLabel};
    text-overflow: ellipsis;
    overflow: hidden;
`;

S.Input = styled(Input)`
    font-family: ${FontFamily};
    font-weight: ${FwBold};
    font-size:  ${rem('14px', baseFont)};   
    color: ${({theme:{$accountResponsibleGameFormInputText}})=> $accountResponsibleGameFormInputText};
    border: none;
    display: block;
    text-align: left;
    height: ${rem('38px', baseFont)};

    &:focus {
        border-bottom-color: #0E62C4;
    }
     
    &[type="number"]{
      -moz-appearance: textfield;
    }
    
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
   
`;

S.SubmitBtn = styled(Button)`
    font-family: ${FontFamily};
    font-weight: ${FwBold};
    height: ${rem('40px', baseFont)};
    width: ${rem('220px', baseFont)};
    margin-bottom: ${rem('20px', baseFont)};
    background-color: ${({theme:{$accountResponsibleGameFormSubmitBtn}})=> $accountResponsibleGameFormSubmitBtn};
    font-size: ${rem('13px', baseFont)};
    color: #fff;
    border-radius: 20px;
    padding: 0 ${rem('10px', baseFont)};
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
`;

S.ClearFormBtn = styled(Button)`
    font-family: ${FontFamily};
    font-weight: ${FwBold};
    height: ${rem('40px', baseFont)};
    width: ${rem('220px', baseFont)};
    background-color: ${({theme:{$accountResponsibleGameFormClearBtn}})=> $accountResponsibleGameFormClearBtn};
    font-size: ${rem('13px', baseFont)};
    color: #fff;
    border-radius: 20px;
    padding: 0 ${rem('10px', baseFont)};
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
`;

S.Error = styled.div`
    color: red;
    float: left;
    width: 100%;
    padding: 2px 0;
    font-size: ${rem('10px', baseFont)};
`;

S.SubmissionError = styled.div`
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: red;
    font-size: ${rem('11px', baseFont)};
    text-align: left;
    padding: .83rem;
    background-color: #fba59f;
    margin-bottom: ${rem('20px', baseFont)};
`;

S.Currency = styled.div`
    font-family: ${FontFamily};
    font-weight: ${FwBold};
    font-size:  ${rem('15px', baseFont)};
    color: ${({theme:{$accountResponsibleGameFormInputText}})=> $accountResponsibleGameFormInputText};
`;

S.Hour = styled(S.Currency)`
    text-transform: lowercase;
`;

S.InputWrapper = styled.div`
    height: 60px;
    display: flex;
    flex-direction: column;
   
    &.with-checkbox{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: ${rem('10px', baseFont)};
        
        ${S.Error}{
           width: 100%;
        }  
        ${S.Label}{
                flex: 1;
                font-size: 1.17rem;
                font-weight: 400;
                padding-top: 0;
                color: #787d83;
                display: flex;
                position: relative;
                left: 0;
                cursor: pointer;
                top: 0;
                
                & a{
                    color: #CE0006;
                }
            }
         ${S.Input}{
            position: absolute!important;
            padding: 0!important;
            border: 0!important;
            overflow: hidden;
            z-index: 0;
            left: 3px;
            top: 1px;
            height: 14px;
            width: auto;
         }
    }
`;

S.ValueWrapper = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    border-bottom: 2px solid #BAC1D0;

    &.has-error{
        border-bottom: 2px solid red;
    }
    &.is-valid{
        border-bottom: 2px solid #BAC1D0;
    }
    &.inputFocused {
        border-bottom: 2px solid ${({theme:{$accountResponsibleGameFormInputFocusedBorder}})=> $accountResponsibleGameFormInputFocusedBorder};
    }
`;

S.Body = styled.div`
`;

S.BodyInner = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    > div {
        flex-basis: ${rem('220px', baseFont)};
    }
    ${({modal})=>{
        if(modal==true){
            return css`
                padding-left: ${rem('53px', baseFont)};
            `;
        }    
    }}
`;

S.Footer = styled.div`
    display: flex;
    flex-direction: column;
    ${({modal})=>{
        if(modal==true){
            return css`
                align-items: center;
                padding-top: ${rem('40px', baseFont)};
            `;
            }    
    }}
`;

S.Info = styled.div`
    margin: 20px 0;
    font-family: ${FontFamily};
    font-weight: ${FwSemibold};
    font-size: ${rem('12px', baseFont)};
    color: ${({theme:{$accountResponsibleGameInfoColor}})=> $accountResponsibleGameInfoColor};
`;

S.FormTitle = styled.h2`
  margin: 0;
  padding-bottom: 16px;
  color: ${({theme:{$accountResponsibleGameTitleColor}})=> $accountResponsibleGameTitleColor};
  font-family: ${FontFamilyOswald};
  font-size: ${rem('14px', baseFont)};
  font-weight: ${FwMedium};
  ${({modal})=>{
    if(modal==true){
        return css`
            text-align: center;
        `;
        }    
    }}
`;

S.LimitUpdateResponse = styled(S.SubmissionError)`
    background-color: transparent;
    border-color: transparent;
    padding-left: 0;
    padding-right: 0;
`;

S.Limit = styled.div`
  font-size: ${rem('11px', baseFont)};
  color: ${({status})=>(status?'green':'red')};
  margin-bottom: ${rem('10px', baseFont)};
  &:last-of-type{
    margin-bottom: 0;
  }
`;

S.LimitName = styled.div`
  font-weight: ${FwSemibold};
`;

S.LimitText = styled.div`
    color: ${({theme:{$accountResponsibleGameFormLabel}})=> $accountResponsibleGameFormLabel};
    line-height: 1.4;
`;

export default S;